<template>
  <gh-table-page :show-tabs="true" ref="table" :args-query="args" module="mes.business.sys.db.service"
    cls="DataTablesService" @viewItem="viewColumns">
    <template #area_query>
      <v-layout row>
        <v-flex xs6 md4>
          <gh-invoke ref='dbs' module="mes.business.sys.db.service" cls="DataTablesService" method="getDbs" :args="{}"
            @start="" @complete="">
            <template v-slot="{args,data,loading}">
              <v-autocomplete :loading="loading" v-model="argsQuery.db" hint="选择要查询的数据库" label="数据库" persistent-hint
                :items="data" @change="$refs.table.query()">
                <template #append-outer>
                  <v-btn icon flat @click="$refs.dbs.invoke()">
                    <v-icon>refresh</v-icon>
                  </v-btn>
                </template>
              </v-autocomplete>
            </template>
          </gh-invoke>
        </v-flex>

        <v-text-field v-model="argsQuery.keyword" counter :autofocus="true" clearable label="关键字"
          append-icon="mdi-circle-edit-outline" @change="$refs.table.query()">
        </v-text-field>

      </v-layout>
    </template>

    <template #area_detail="{current}">
      <table-column :table-id="tableId">

      </table-column>
     

    </template>
  </gh-table-page>
</template>

<style scoped>

</style>

<script>
  import Database from "./database.ts";
  export default Database;
</script>